
import { Observable } from './druid/./druid/Observable';
import { debounceTime } from './druid/./druid/operator/debounceTime';

Observable.prototype.debounceTime = debounceTime;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    debounceTime: typeof debounceTime;
  }
}